<template>
    <el-drawer
        :title="!formData.id ? '新增权限' : '编辑权限'"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-alert type="warning" show-icon title="注意事项" :closable="false">
                <p>第一级: 类型若为链接的会展示在左侧目录,若为按钮的及子级不展示在左侧目录,如果有二级无需加链接地址</p>
                <p>第二级: 类型若为链接的会展示在左侧目录,且链接地址必须为页面路由地址,若为按钮的不展示在左侧目录</p>
                <p>第三级及以下: 类型请选择按钮类型,并且链接地址为接口地址</p>
            </el-alert>
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                class="MT20"
            >
                <el-row :gutter="30">
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="priName" label="名称:">
                            <el-input
                                v-model="formData.priName"
                                placeholder="请输入名称"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="type" label="类型:">
                            <el-select v-model="formData.type" placeholder="请选择类型" size="medium">
                                <el-option label="链接" :value="1"></el-option>
                                <el-option label="按钮" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="link" label="链接:">
                            <el-input
                                v-model="formData.link"
                                placeholder="请输入链接"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="sort" label="序号:">
                            <el-input
                                v-model="formData.sort"
                                placeholder="请输入序号"
                                type="number"
                                size="medium"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12"> 
                        <el-form-item prop="behaviorType" label="行为类型:">
                            <el-select v-model="formData.behaviorType" placeholder="请选择行为类型" size="medium">
                                <el-option label="新增" :value="1"></el-option>
                                <el-option label="管理" :value="2"></el-option>
                                <el-option label="页面访问" :value="3"></el-option>
                                <el-option label="导出" :value="4"></el-option>
                                <el-option label="导入" :value="5"></el-option>
                                <el-option label="登录" :value="6"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24"  :md="12"> 
                        <el-form-item prop="description" label="描述:">
                            <el-input
                                v-model="formData.description"
                                type="textarea"
                                placeholder="请输入描述"
                                maxlength="200"
                                show-word-limit
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="loading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    priName: "",
    type: 2,
    link: "",
    sort: 0,
    description: "",
    parentId:  0,
    behaviorType:''
}
export default {
    props: {
        data: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            drawerShow: false,
            loading: false,
            formData: {
                ...defaultFormData,
                parentId:this.$route.query.pid 
            },
            rules: {
                priName: [{ required: true, message: "请输入名称" }],
                sort: [{ required: true, message: "请输入序号" }],
                behaviorType: [{ required: true, message: "请选择行为类型" }],
            },
        };
    },
    // watch: {
    //     data(val){
    //         this.formData = val
    //         ? { ...val }
    //         : {...defaultFormData,parentId:this.$route.query.pid };
    //     }
    // },
    methods: {
        close() {
            this.formData = {...defaultFormData,parentId:this.$route.query.pid};
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(data) {
            this.formData = {...defaultFormData,...data,parentId:this.$route.query.pid };
            this.drawerShow = true;
        },
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    const _url = this.formData.id
                        ? "/suduPrivilege/edit"
                        : "/suduPrivilege/add";
                    this.loading = true;
                    this.$request({
                        url: _url,
                        data: this.formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                self.$router.push({
                                    path: "/system/fb/privilege/list",
                                    query: {
                                        ...self.$route.query,
                                        v: new Date().getTime(),
                                    },
                                });
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>